import type { OpenLoanCheckRequest } from "@credit-acceptance/step6-bff-client";

export const openLoanCheckKeys = {
  all: ["openLoanCheck"] as const,
  // Includes the built request (dealerId, receipt date, applicant DOBs) so an
  // edit to any of those fields busts the cache instead of serving a stale
  // check built from the old values within the query's staleTime window.
  check: (approvalId: string, request: OpenLoanCheckRequest | undefined) =>
    [...openLoanCheckKeys.all, approvalId, request] as const,
};
